import AppLink from '@/components/common/AppLink';
import React, { ReactNode } from 'react';
import styles from '../styles.module.scss';
import MainIcons from '@/icons/main';

export default function MenuItem({
  item,
  children,
  active = false,
}: {
  item: {
    id?: number | string;
    title?: string;
    href?: string;
    parent?: string;
    onClick?: () => void;
  };
  children?: ReactNode;
  active?: boolean;
}) {
  const renderItem = () => (
    <>
      <span className={`${styles.menuTitle}`}>
        {children} {item?.title}
      </span>
      <MainIcons.arrowIcon className="rotateIcon-rtl" fill="var(--text-dark)" />
    </>
  );
  return (
    <>
      {item?.href ? (
        <AppLink
          href={item?.href}
          title={item?.title}
          className={`${styles.menuItem} ${active && styles.active}`}
          // target="_blank"
        >
          {renderItem()}
        </AppLink>
      ) : (
        <div
          style={{ cursor: 'pointer' }}
          className={`${styles.menuItem} ${active && styles.active}`}
          onClick={item?.onClick}
        >
          {renderItem()}
        </div>
      )}
    </>
  );
}
